export const SALES_AGREEMENT_DETAIL_BREADCRUMB = 'Salgsavtale'
